import { render, staticRenderFns } from "./sendedPorposal.vue?vue&type=template&id=2c825d44&"
import script from "./sendedPorposal.vue?vue&type=script&lang=ts&"
export * from "./sendedPorposal.vue?vue&type=script&lang=ts&"
import style0 from "./sendedPorposal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports